import secureLocalStorage from "react-secure-storage";
import { TextArea } from "@progress/kendo-react-inputs";
import * as React from "react";
import "../../Styles/RiskDiscription.scss";

export default class ActionTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temp: this.props.dataItem[this.props.field],
      risktitleclass: "k-grid-content-sticky k-grid-content-sticky-temp  inlineEditField"
    };
  }
  componentDidMount = () => {
    if (
      this.props.dataItem.inEdit &&
      document.getElementById("mitigationnameId")
    ) {
      document.getElementById("mitigationnameId").focus();
    }
  };
  reportWindowSize = () => {
    if (window.innerWidth > 768) {
      this.setState({ risktitleclass: "k-grid-content-sticky" })
    }
    else {
      this.setState({ risktitleclass: "" })
    }
  }
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
  };
  handleEditCell = () => {
    if ((this.props.dataItem.isOpen === "Open" || this.props.dataItem.isOpen === true) || (this.props.dataItem.isOpen === undefined)) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const riskOwnerId = this.props.riskDetails
      ? this.props.riskDetails.userId
      : null;
    const dataValue =
      dataItem[field] === null || dataItem[field] === undefined
        ? ""
        : dataItem[field];
        const style=this.props.pageName?{ left: '380px', right: "210px" }:{ left: '0px', right: "0px" };
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td className={this.state.risktitleclass}>
          <TextArea
            defaultValue={dataValue}
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            id="mitigationnameId"
          />
        </td>
      );
    } else {
      if (
        (loginUserId === ownerId || loginUserId === riskOwnerId) &&
        this.props.dataItem.isOpen === true
      ) {
        return (
          <td style={style} title={dataValue} onClick={this.handleEditCell} className={this.state.risktitleclass}>
            {dataValue}
          </td>
        );
      } else {
        return this.props.dataItem.role === "View Only" ||
          this.props.dataItem.role === "Standard User" ||
          this.props.dataItem.isOpen === false ? (
          <td title={dataValue} className={this.state.risktitleclass}
            style={style}>{dataValue}</td>
        ) : (
          <td title={dataValue} onClick={this.handleEditCell} 
          className={this.state.risktitleclass} 
          style={style}>
            {dataValue}
          </td>
        );
      }
    }
  }
}
